<template>
  <el-dialog
    title="取消录用原因"
    :visible.sync="visible"
    width="28%"
    :show-close="false"
    :destroy-on-close="true"
    center
  >
    <el-form class="form" ref="form" :model="form" :rules="rules">
      <el-form-item prop="reason">
        <el-radio-group v-model="form.reason">
          <p><el-radio label="双方友好协商">双方友好协商</el-radio></p>
          <p>
            <el-radio style="margin-top: 15px" label="联系不上对方"
              >联系不上对方</el-radio
            >
          </p>
          <p>
            <el-radio style="margin-top: 15px" label="条件不符"
              >条件不符</el-radio
            >
          </p>
          <p>
            <el-radio style="margin-top: 15px" label="应聘者放鸽子"
              >应聘者放鸽子</el-radio
            >
          </p>
          <p><el-radio style="margin-top: 15px" label="其他">其他</el-radio></p>
        </el-radio-group>
        <el-input
          v-model="form.otherReason"
          placeholder="请输入其他原因"
          type="textarea"
          :disabled="form.reason !== '其他'"
          style="margin-top: 15px"
        ></el-input>
      </el-form-item>
      <el-form-item prop="note">
        <el-input
          v-model="form.note"
          placeholder="补充说明"
          type="textarea"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('form')" size="medium"
        >确 认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import BaseDialog from "../BaseDialog";
import Api from "@/api";
export default {
  name: "CancelOffer",
  extends: BaseDialog,
  data() {
    return {
      form: {
        reason: "",
        otherReason: "",
        note: "",
      },
      post_id: "",
      rules: {},
    };
  },
  mounted() {},
  methods: {
    open(id) {
      this.visible = true;
      this.post_id = id;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let params = {
              ids: this.post_id,
              reason:
                this.form.reason === "其他"
                  ? this.form.otherReason
                  : this.form.reason,
              note: this.form.note,
            };
            let res = await Api.post.parTimeDeleteJob(params);
            if (res) {
              this.$message.success("取消成功");
              this.close();
              this.callback && this.callback();
            }
          } catch (e) {}
          this.loading = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin: 0 auto;
  width: 80%;
}
</style>